// extracted by mini-css-extract-plugin
module.exports = {"prevBtn":"Reports_prevBtn__1eBmb","nextBtn":"Reports_nextBtn__3chZp","reportsPreload":"Reports_reportsPreload__1Nlnh"};